import styled from "styled-components";

export const GridItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};
  background-color: ${(props) => props.theme.theme.BACKGROUND.SURFACE};
  max-width: auto;
  height: 100%;

  &:hover {
    box-shadow: 0 0 3px ${(props) => props.theme.theme.BOX_SHADOW};
  }

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

export const GridItemHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 !important;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const GridItemBody = styled.div`
  border-top: none;
  background-color: ${(props) => props.theme.theme.BACKGROUND.SURFACE};
  text-align: justify;
  height: 100%;
`;

export const GridItemFooter = styled.div`
  max-width: 100%;
  overflow: hidden;
  overflow-x: auto;
  display: flex;
  justify-content: space-between;
  direction: rtl;
  align-items: center;
  margin-top: 1rem;
  border-top: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};

  button {
    color: ${(props) => props.theme.theme.TEXT.PRIMARY};
    font-size: ${(props) =>
      props.theme.fontSize === "sm"
        ? "16px"
        : props.theme.fontSize === "md"
        ? "20px"
        : "24px"} !important;
    }

    &:focus {
      background-color: ${(props) => props.theme.theme.BACKGROUND.SURFACE};
      outline: none;
    }

    &:hover {
      color: ${(props) => props.theme.theme.COLOR_ACCENT};
    }
  }
`;
